"use strict";

exports.__esModule = true;
exports.default = src;

/**
 * Is image source
 */
function src(url) {
  return /^(https?:)?\/\/|data:image/.test(url);
}


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/utils/validate/src.js
// module id = 650
// module chunks = 1